import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateModelo145 = () => {
  const [loadingCreateModelo145, setLoadingCreateModelo145] = useState(false);
  const [successCreateModelo145, setSuccessCreateModelo145] = useState(false);
  const [errorCreateModelo145, setErrorCreateModelo145] = useState(null);
  const [dataCreateModelo145, setDataModelo145] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createModelo145 = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateModelo145(true);
    setSuccessCreateModelo145(false);
    setErrorCreateModelo145(null);

    apiRecord.newModelo145It(userId, data)
      .then((res: any) => {
        setLoadingCreateModelo145(false);
        setSuccessCreateModelo145(true);
        setDataModelo145(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateModelo145(false);
        setErrorCreateModelo145(err.response?.data);
      });
  };

  return {
    createModelo145,
    loadingCreateModelo145,
    successCreateModelo145,
    errorCreateModelo145,
    dataCreateModelo145
  };
};

export default useCreateModelo145;
